import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import { ThemeProvider } from "./contexts/ThemeContext";
import { UserDetailsProvider } from "./contexts/UserDetailsContext";
import { CreateProvider } from "./contexts/CreateContext";
import AuthInitializer from "./components/auth/AuthInitializer";
import { NotificationProvider } from "./contexts/NotificationContext";

const glitchTipDsn = process.env.REACT_APP_GLITCHTIP_DSN;
if (glitchTipDsn) {
  Sentry.init({
    dsn: glitchTipDsn,
    // debug: when true, Sentry logs to the browser console (captured events, send failures, etc.).
    // Only enable in development to avoid noisy console in UAT/Production. GlitchTip still works in all envs.
    debug: process.env.NODE_ENV === "development",
    sendDefaultPii: false,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}>
      <ThemeProvider>
        <UserDetailsProvider>
          <CreateProvider>
            <NotificationProvider>
              <AuthInitializer>
                <App />
              </AuthInitializer>
            </NotificationProvider>
          </CreateProvider>
        </UserDetailsProvider>
      </ThemeProvider>
    </Provider>
);
